export enum orderStatuses{
    NotSet = 0,
    New = 100,
    Active = 101,
    InStore = 109,
    OnHold = 110,
    ReadyForDelivery = 200,
    VerifiedForDelivery = 290,
    Intransit = 300,
    UnQueued = 301,
    OngoingTakenByPicker = 302,
    IntransitLocker = 303,
    Delivered = 400,
    DeliverdWithDeviation = 401,
    ChangedReceiver = 402,
    DeliveredLocker = 403,
    Rejected = 500,
    Canceled = 600,
    Removed = 650,
    UnDelivered = 700,
    LessThen200 = 0
}
